import {
    CellFormatterService,
    TableOptions,
    FormatterOptions
} from '../common/datatable';
import { AuditModifiedFieldComponent } from './audit-modified-fields/audit-modified-field.component';
import { AuditClassFactory } from './audit-class-maker';

export class AuditProtocolsTasksTableOptions {

    options: TableOptions;

    constructor(
        private cellFormatterService: CellFormatterService
    ) {
        this.options = this.getDefaultOptions();
    }

    getDefaultOptions(): TableOptions {

        return {
            csvFileName: 'protocolsTasks-audit.csv',
            enableDetailColumn: false,
            enableDraggable: false,
            enableSelectable: false,
            enableAuditColumns: false,
            columns: [
                {
                    displayName: 'Type',
                    field: 'UpdateType',
                    cellClass: AuditClassFactory.createDeletedClass,
                },
                {
                    displayName: 'Modified Fields',
                    field: 'ModifiedFields',
                    sortField: 'ModifiedFields',
                    rendererComponent: AuditModifiedFieldComponent,
                    exportFormatter: this.cellFormatterService.auditModifiedFieldsExportFormatter,
                    cellClass: AuditClassFactory.createDeletedClass,
                },
                {
                    displayName: 'Date',
                    field: 'ModifiedDate',
                    formatter: this.cellFormatterService.dateTimeUTCFormatter,
                    cellClass: AuditClassFactory.createDeletedClass,
                },
                {
                    displayName: 'Modified By',
                    field: 'ModifiedBy',
                    formatter: this.cellFormatterService.userNameFormatter,
                    cellClass: AuditClassFactory.createDeletedClass,
                },
                {
                    displayName: 'Protocol',
                    field: 'ProtocolName',
                    formatter: this.cellFormatterService.createAuditColumnFormatter('ProtocolName', 'ProtocolName'),
                    cellClass: AuditClassFactory.createCellClass('protocol'),
                },
                {
                    displayName: 'Task',
                    field: 'TaskName',
                    formatter: this.cellFormatterService.createAuditColumnFormatter('TaskName', 'TaskName'),
                    cellClass: AuditClassFactory.createCellClass('task'),
                },
                {
                    displayName: 'Time',
                    field: 'Time',
                    formatter: this.cellFormatterService.createAuditColumnFormatter('Time', 'Time'),
                    cellClass: AuditClassFactory.createCellClass('time'),
                },                
                {
                    displayName: 'Time Unit',
                    field: 'TimeUnit',
                    formatter: this.cellFormatterService.createAuditColumnFormatter('TimeUnit', 'TimeUnit'),
                    cellClass: AuditClassFactory.createCellClass('timeunit'),
                },
                {
                    displayName: 'Time Relation',
                    field: 'TimeRelation',
                    formatter: this.cellFormatterService.createAuditColumnFormatter('TimeRelation', 'TimeRelation'),
                    cellClass: AuditClassFactory.createCellClass('timerelation'),
                },
                {
                    displayName: 'Relation To',
                    field: 'RelationTo',
                    formatter: this.cellFormatterService.createAuditColumnFormatter('RelationTo', 'RelationTo'),
                    cellClass: AuditClassFactory.createCellClass('relationto'),
                },
                {
                    displayName: 'Relative Task',
                    field: 'RelativeTask',
                    formatter: this.cellFormatterService.createAuditColumnFormatter('RelativeTask', 'RelativeTask'),
                    cellClass: AuditClassFactory.createCellClass('relativetask'),
                },
                {
                    displayName: 'Task Alias',
                    field: 'TaskAlias',
                    formatter: this.cellFormatterService.createAuditColumnFormatter('TaskAlias', 'TaskAlias'),
                    cellClass: AuditClassFactory.createCellClass('taskalias'),
                },
                {
                    displayName: 'Created By',
                    field: 'CreatedBy',
                    formatter: this.cellFormatterService.userNameFormatter,
                    cellClass: AuditClassFactory.createDeletedClass,
                },
                {
                    displayName: 'Created Date',
                    field: 'DateCreated',
                    formatter: this.cellFormatterService.dateTimeUTCFormatter,
                    cellClass: AuditClassFactory.createDeletedClass,
                }
            ]
        };
    }
}
